import axios from "axios";

/**
 * A reusable component to inject a product
 *
 * @class QuickView
 * @typedef {QuickView}
 * @extends {HTMLElement}
 */
class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  static get observedAttributes() {
    return ["in-use"];
  }


  /**
   *  Fetch the liquid content of the queried product by handle and insert into the dom
   *
   * @async
   * @param {String} h - the product handle to get the associated product json
   * @returns {*}
   */
  hydrateQuickView = async (h) => {
    const fetchUrl = `${window.routes.root_url}products/${h}?view=quick-view`;

    try {
      const response = await axios.get(fetchUrl);
      const res = await response;

      if (res.status !== 200) {
        throw new Error(`Request failed with status ${res.status}`);
      }

      let parser = new DOMParser();
        let doc = parser.parseFromString(res.data, "text/html");
        let productData = doc.querySelector('.dynamic-pdp');
        this.appendChild(productData);
        this.querySelector('.loader-wrapper')?.remove();

        this.querySelector('.closer').addEventListener('click',()=>{
          this.toggleQuickView();
        })


    } catch (err) {
      console.log(err);
    }

  }

  toggleQuickView() {

    let _loader = ` <div class="loader-wrapper">
    <span id="quick-view-loader" class="spinner"></span>
  </div>`;

    this.innerHTML = _loader;
    this.classList.toggle('open');
  }

}
customElements.define('quick-view', QuickView);

/* ============================================================================
  Quick view trigger
============================================================================== */


/**
 * Button that opens the quick view container
 *
 * @class QuickViewTrigger
 * @typedef {QuickViewTrigger}
 * @extends {HTMLElement}
 */
class QuickViewTrigger extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (e) => this.handleQuickView(e))
  }

  handleQuickView(e) {
    e.preventDefault();
    e.stopPropagation();
    const quickView = document.querySelector('quick-view');
    if(!quickView) return;

    // also prevent add ons popup being open when a product quick view is open
    // const hasAddOns = document.querySelector('.add-ons');
    // if(hasAddOns){
    //   document.querySelector('.add-ons').classList.add('closed');
    //   document.querySelector('body').classList.remove('locked');
    // }

    quickView.hydrateQuickView(this.dataset.handle);
    quickView.setAttribute('in-use', true);
    quickView.classList.toggle('open');
  }
}
customElements.define('quick-view-trigger', QuickViewTrigger);
